import React, { useState, useEffect } from "react";
import "../styles/DiscountCountdown.css";
import { startDate, endDate, campaignTitle } from "./discountPeriod";

const DiscountCountdown = () => {
  const [timeLeft, setTimeLeft] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const calculateTimeLeft = () => {
    const now = new Date();
    if (now >= startDate && now < endDate) {
      const difference = endDate - now;
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / (1000 * 60)) % 60);
      const seconds = Math.floor((difference / 1000) % 60);
      return { days, hours, minutes, seconds };
    }
    return null;
  };

  useEffect(() => {
    // 期間外であれば非表示のまま終了
    const initialTimeLeft = calculateTimeLeft();
    if (!initialTimeLeft) {
      setIsVisible(false);
      return;
    }

    // 期間中の場合、即時表示
    setTimeLeft(initialTimeLeft);
    setIsVisible(true);

    // 1秒ごとにカウントダウンを更新
    const timer = setInterval(() => {
      const updatedTimeLeft = calculateTimeLeft();
      if (updatedTimeLeft) {
        setTimeLeft(updatedTimeLeft);
      } else {
        // 期間外になったら非表示
        setIsVisible(false);
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (!isVisible || !timeLeft) return null;

  return (
    <div className="countdown-wrap">
      <h2>
        <strong>{campaignTitle}<br />キャンペーン実施中！</strong>
      </h2>
      <div className="countdown-title">残り時間</div>
      <div className="countdown">
        <div className="bloc-time days">
          <span className="count-title">Days</span>
          <div className="figure">{String(timeLeft.days).padStart(2, "0")}</div>
        </div>
        <div className="bloc-time hours">
          <span className="count-title">Hours</span>
          <div className="figure">{String(timeLeft.hours).padStart(2, "0")}</div>
        </div>
        <div className="bloc-time minutes">
          <span className="count-title">Minutes</span>
          <div className="figure">{String(timeLeft.minutes).padStart(2, "0")}</div>
        </div>
        <div className="bloc-time seconds">
          <span className="count-title">Seconds</span>
          <div className="figure">{String(timeLeft.seconds).padStart(2, "0")}</div>
        </div>
      </div>
      {(timeLeft.days * 24 + timeLeft.hours) >= 120 && (
        <div className="limited-offer-message">
          <span className="message-text">定員に達し次第キャンペーンを終了いたします</span>
        </div>
      )}
    </div>
  );
};

export default DiscountCountdown;

